import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorsInterceptor } from './errors.interceptor';
import { ResponseParseInterceptor } from './response-parse.interceptor';
import { TokenInterceptor } from './token.interceptor';

export const INTERCEPTOR_RESPONSE_PARSE = {
    provide: HTTP_INTERCEPTORS,
    useClass: ResponseParseInterceptor,
    multi: true,
};

export const INTERCEPTOR_TOKEN = {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true,
};

export const INTERCEPTOR_ERROR= {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorsInterceptor,
    multi: true,
};